/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Regenerate_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo rewrites the whole preparation. Everything you wrote or edited in it is lost. Your action items stay." |
*
* @param {Meeting_Prep_Regenerate_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_regenerate_body = /** @type {((inputs?: Meeting_Prep_Regenerate_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Regenerate_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo schrijft de voorbereiding helemaal opnieuw. Wat je er zelf in schreef of aanpaste, gaat verloren. Je actiepunten blijven staan.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo réécrit toute la préparation. Ce que vous y avez écrit ou modifié vous-même est perdu. Vos points d'action restent.")
	return /** @type {LocalizedString} */ ("Wundo rewrites the whole preparation. Everything you wrote or edited in it is lost. Your action items stay.")
});